var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PlayListDetail',{attrs:{"loading":_vm.loading,"listInfo":_vm.listInfo,"id":_vm.id,"trueList":_vm.list,"platform":_vm.$route.query.from}})
}
var staticRenderFns = []

export { render, staticRenderFns }